import { AxiosService } from '@/shared/utils'
import { AxiosRequestConfig } from 'axios'

export class PasswordApi extends AxiosService {
  constructor(config?: AxiosRequestConfig) {
    super(config)
  }

  public sendPasswordEmail(email: string) {
    return this.axiosCall({
      method: 'post',
      url: '/api/web/password/email',
      data: {
        email,
      },
    })
  }

  public changePassword(password: string, token: string) {
    return this.axiosCall({
      method: 'post',
      url: '/api/web/password/reset',
      data: {
        password,
        token,
      },
    })
  }

  public changePasswordOnFirstLogin(
    password: string,
    passwordConfirmation: string
  ) {
    return this.axiosCall({
      method: 'post',
      url: '/api/web/admin/password-change',
      data: {
        password,
        password_confirmation: passwordConfirmation,
      },
    })
  }
}

export const passwordApi = new PasswordApi({
  baseURL:
    process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASE_URI : '',
  withCredentials: true,
})
